import { Toaster as Sonner, type ToasterProps } from "sonner";
import { Icon } from "@/components/Icon";

const toastIcons: ToasterProps["icons"] = {
  success: <Icon name="check_circle" size="smaller" className="text-positive" />,
  error: <Icon name="error" size="smaller" className="text-destructive" />,
  info: <Icon name="info" size="smaller" className="text-primary" />,
};

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner position="bottom-right" closeButton richColors={false} duration={5000} icons={toastIcons} {...props} />
  );
}

export { Toaster };
